var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 10.3751C11.2812 13.5117 8.75578 16.0545 5.6407 16.0545C2.52561 16.0545 0 13.5117 0 10.3751C0 7.23845 2.52542 4.69553 5.6407 4.69553C8.75597 4.69553 11.2812 7.23845 11.2812 10.3751Z",
    fill: "#94A3B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4688 10.3751C17.4688 13.3276 16.2061 15.722 14.6485 15.722C13.0908 15.722 11.8281 13.3276 11.8281 10.3751C11.8281 7.42263 13.0906 5.02823 14.6483 5.02823C16.2059 5.02823 17.4686 7.42186 17.4686 10.3751",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 10.3751C20.0003 13.0198 19.5562 15.165 19.0083 15.165C18.4604 15.165 18.0166 13.0203 18.0166 10.3751C18.0166 7.7298 18.4606 5.58511 19.0083 5.58511C19.556 5.58511 20.0003 7.72961 20.0003 10.3751Z",
    fill: "#94A3B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.19fbb49f.svg";
export { ForwardRef as ReactComponent };